import { Box } from '@chakra-ui/react'
import { type QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'

import { InvalidLinkState } from '@/widgets/invalid-link-state'

export interface MyRouterContext {
    queryClient: QueryClient
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
    component: Root,
    notFoundComponent: InvalidLinkState,
})

function Root() {
    return (
        <Box bg='#F4F4F5' minH='100dvh' w='full'>
            <Outlet />
        </Box>
    )
}
